document.addEventListener('DOMContentLoaded', () => {
  const toggleBtn = document.getElementById('ai-assistant-toggle');
  const closeBtn = document.getElementById('ai-assistant-close');
  const windowEl = document.getElementById('ai-assistant-window');
  const input = document.getElementById('ai-assistant-input');
  const sendBtn = document.getElementById('ai-assistant-send');
  const messagesContainer = document.getElementById('ai-assistant-messages');
  
  const style = document.createElement('style');
  style.innerHTML = `
    .ai-assistant-options { display: flex; flex-wrap: wrap; gap: 8px; margin: 10px 0; }
    .ai-assistant-option-btn { 
      background: #f0f0f0; border: 1px solid #ddd; border-radius: 15px; 
      padding: 8px 12px; font-size: 0.85rem; cursor: pointer; transition: all 0.2s;
      color: #333;
    }
    .ai-assistant-option-btn:hover { background: #e0e0e0; border-color: #bbb; }
  `;
  document.head.appendChild(style);

  if (!toggleBtn || !windowEl) return;
  
  let isOpen = false;
  
  const welcomeMessage = { 
    role: 'model', 
    text: '¡Guau! Hola, soy Leo, tu asesor experto en SecurePets. Tengo las respuestas más completas sobre nuestro premiado Arnés de Coche Babyauto Pets, las camas artesanas Ghana, envíos, tallas, pagos y soporte. ¡Pregúntame sin miedo!' 
  };
  
  const menuOptions = [
    "🚗 Arnés de Coche",
    "🛏️ Camas Ghana",
    "📐 Guía de Tallas",
    "🚚 Envíos y Pagos",
    "📧 Ayuda y Contacto"
  ];

  function toggle() {
    isOpen = !isOpen;
    if (isOpen) {
      windowEl.classList.add('open');
      toggleBtn.classList.add('open');
      if(messagesContainer) messagesContainer.scrollTop = messagesContainer.scrollHeight;
      if(input) input.focus();
    } else {
      windowEl.classList.remove('open');
      toggleBtn.classList.remove('open');
    }
  }
  
  toggleBtn.addEventListener('click', toggle);
  if (closeBtn) closeBtn.addEventListener('click', toggle);
  
  function normalizeText(text) {
    return text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  async function sendMessage(text = null) {
    const messageText = text || input.value.trim();
    if (!messageText) return;
    
    if(input) input.disabled = true;
    if(sendBtn) sendBtn.disabled = true;
    
    addMessage(messageText, 'user');
    if(input) input.value = '';
    
    const loadingId = addLoading();
    
    try {
      const response = await fetch('/apps/ai-assistant/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: messageText })
      });
      
      if (response.ok) {
        const data = await response.json();
        removeLoading(loadingId);
        addMessage(data.reply, 'model');
      } else {
        throw new Error('API error');
      }
    } catch (error) {
      removeLoading(loadingId);
      setTimeout(() => {
          const fallbackResponse = getFallbackResponse(messageText);
          addMessage(fallbackResponse, 'model');
      }, 500);
    }
    
    if(input) {
        input.disabled = false;
        input.focus();
    }
    if(sendBtn) sendBtn.disabled = false;
  }
  
  function getFallbackResponse(text) {
    const cleanText = normalizeText(text);
    const containsAny = (keywords) => keywords.some(kw => cleanText.includes(kw));

    // Categoría 1: Ayuda, Contacto, Soporte
    if (containsAny(['contacto', 'contactar', 'ayuda', 'servicio al cliente', 'atencion', 'email', 'correo', 'soporte', 'problema', 'duda', 'hablar', 'humano', 'asesor'])) {
      return '📧 ¡Aquí estoy para ayudarte! Si necesitas asistencia personalizada, un humano te atenderá encantado en **contacto@securepets.es**. También puedes enviarnos un mensaje rápido usando el formulario de nuestra página. ¡Resolveremos tu duda muy pronto!';
    
    // Categoría 2: Arnés (🚗 Seguridad en Coche)
    } else if (containsAny(['arnes', 'coche', 'viaje', 'babyauto', 'viajar', 'seguridad', 'premio', 'cinturon'])) {
      return '🚗 ¡Seguridad de premio para tus viajes! Nuestro <a href="/products/tu-arnes-seguridad" class="ai-assistant-product-link">Arnés Babyauto Pets</a> ha sido galardonado en los Celebrity Pets Awards. Diseñado con materiales transpirables, ofrece ergonomía total sin perder firmeza. Inspirado en sistemas de alta protección, garantiza que tu mascota viaje segura y tú conduzcas con máxima tranquilidad.';

    // Categoría 3: Camas Ghana (🛏️ Artesanía Pura)
    } else if (containsAny(['cama', 'ghana', 'modelo', 'tamale', 'kumari', 'accra', 'cesta', 'capazo'])) {
      return '🛏️ ¡Artesanía pura! Las <a href="/products/tu-cama-ghana" class="ai-assistant-product-link">camas Ghana</a> son piezas únicas tejidas a mano por artesanos usando "Hierba de Elefante", lo que les da una resistencia increíble y durabilidad para años. Priorizan el confort absoluto de tu mascota. Al elegirlas, apoyas directamente a nuestro proyecto social. ¡Una inversión en descanso y propósito!';

    // Categoría 4: Precios y Cojines (💰 Transparencia Total)
    } else if (containsAny(['precio', 'costo', 'cojin', 'cuesta', 'incluye', 'vale', '€ '])) {
      return '💰 Te cuento: Camas 140€ (Talla S) y 160€ (Talla M). El cojín **NO ESTÁ INCLUIDO** para que puedas elegir el que mejor se adapte al confort de tu perro (o usar uno que ya tengas). El precio del arnés Babyauto lo verás directamente en su página de producto. ¡Sin sorpresas!';

    // Categoría 5: Envíos y Tiempos (🚚 Veloz y Seguro)
    } else if (containsAny(['envio', 'tarda', 'devol', 'garantia', 'llegar', 'cambio', 'tiempo'])) {
      return '🚚 ¡Veloz y seguro! Realizamos envíos **gratuitos y asegurados con entrega en 24-48h laborables**. Además, te ofrecemos una política de **30 días para cambios o devoluciones** sin complicaciones si la talla no te convence. ¡Cero riesgos!';
    
    // Categoría 6: Tallas y Medidas (📐 Guía Precisa)
    } else if (containsAny(['talla', 'raza', 'medida', 'pequeño', 'grande', 'mediano', 'tallaje'])) {
      return '📐 ¡La clave está en medir! Camas: **Talla S** ideal para razas pequeñas y **Talla M** para razas medianas. Arnés Babyauto: Es **fundamental revisar la talla adecuada midiendo a tu mascota** antes de la compra para garantizar un ajuste y seguridad óptimos en el coche. ¡Si tienes dudas, pregúntanos!';
    
    // Categoría 7: Lavado y Cuidado (🧼 Fácil Mantenimiento)
    } else if (containsAny(['lavar', 'limpiar', 'limpieza', 'lavado', 'mancha', 'cuidado', 'mantenimiento'])) {
      return '🧼 ¡Fácil mantenimiento! Arnés Babyauto: Límpialo simplemente con un paño húmedo para conservar todas sus propiedades con el uso regular. Camas Ghana: Al ser fibras naturales, basta con un paño ligeramente humedecido con agua y dejarlas secar al aire libre.';

    // Categoría 8: Pagos (💳 Seguro al 100%)
    } else if (containsAny(['pago', 'pagar', 'tarjeta', 'paypal', 'bizum', 'metodo'])) {
      return '💳 ¡Pagos rápidos y totalmente seguros! Aceptamos tarjeta de crédito/débito, PayPal y sistemas acelerados como Shop Pay o Apple/Google Pay. ¡Todo encriptado para tu tranquilidad!';

    // Categoría 9: Marca y Valores (🐾 Somos SecurePets)
    } else if (containsAny(['securepets', 'quienes somos', 'marca', 'valores', 'filosofia', 'origen', 'historia'])) {
      return '🐾 Somos SecurePets y nos guían tres pilares: Seguridad, Innovación y Empatía. Creamos productos que protegen a las mascotas con diseños a prueba de todo, inspirando tranquilidad a familias responsables con tecnología de vanguardia y compromisos sociales reales.';
      
    // Categoría 10: Stock y Compra
    } else if (containsAny(['comprar', 'stock', 'disponible', 'añadir', 'carrito'])) {
      return 'Actualmente contamos con stock de todos nuestros productos. ¡Añade tu talla al carrito desde el menú superior!';

    // Respuesta por defecto
    } else {
      return 'Guau, soy Leo, el asistente experto. Puedo resolver tus dudas sobre el Arnés de coche Babyauto Pets, las camas artesanas Ghana, guía de tallas, envíos y devoluciones o cómo contactar con nuestro equipo. ¡Dime qué necesitas saber!';
    }
  }
  
  function addMessage(text, role) {
    const messageDiv = document.createElement('div');
    messageDiv.className = `ai-assistant-message ai-assistant-message-${role}`;
    
    const formattedText = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br>');
    
    const contentDiv = document.createElement('div');
    contentDiv.className = 'ai-assistant-message-content';
    contentDiv.innerHTML = formattedText;
    
    messageDiv.appendChild(contentDiv);
    messagesContainer.appendChild(messageDiv);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }

  function renderMenu(options) {
    const menuDiv = document.createElement('div');
    menuDiv.className = 'ai-assistant-options';
    
    options.forEach(optionText => {
      const btn = document.createElement('button');
      btn.className = 'ai-assistant-option-btn';
      btn.textContent = optionText;
      btn.onclick = () => sendMessage(optionText);
      menuDiv.appendChild(btn);
    });
    
    messagesContainer.appendChild(menuDiv);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
  }
  
  function addLoading() {
    const loadingDiv = document.createElement('div');
    loadingDiv.className = 'ai-assistant-loading';
    loadingDiv.id = 'loading-' + Date.now();
    
    const contentDiv = document.createElement('div');
    contentDiv.className = 'ai-assistant-loading-content';
    const dotsDiv = document.createElement('div');
    dotsDiv.className = 'ai-assistant-loading-dots';
    
    for (let i = 0; i < 3; i++) {
      const dot = document.createElement('div');
      dot.className = 'ai-assistant-loading-dot';
      if (i > 0) dot.style.animationDelay = (i * 0.1) + 's';
      dotsDiv.appendChild(dot);
    }
    contentDiv.appendChild(dotsDiv);
    loadingDiv.appendChild(contentDiv);
    messagesContainer.appendChild(loadingDiv);
    messagesContainer.scrollTop = messagesContainer.scrollHeight;
    return loadingDiv.id;
  }
  
  function removeLoading(id) {
    const el = document.getElementById(id);
    if (el) el.remove();
  }
  
  if (sendBtn) {
    sendBtn.addEventListener('click', () => sendMessage());
  }
  
  if (input) {
    input.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') sendMessage();
    });
  }
  
  if (messagesContainer) {
    messagesContainer.innerHTML = '';
    addMessage(welcomeMessage.text, welcomeMessage.role);
    renderMenu(menuOptions);
  }
});